module.exports = __webpack_public_path__ + "img/84.33765530.jpg";